import jwt from 'jsonwebtoken'
import { getTenantInfo } from './Storage'

export const setToken = (token) => sessionStorage.setItem('token', token)
export const getToken = () => getEncodedToken() ? jwt.decode(getEncodedToken()) : null
export const getEncodedToken = () => sessionStorage.getItem('token')
export const Tenant = () => getTenantInfo(+getToken().ten)
export const SesionActiva = () => getEncodedToken() ? true : false

export const setCajaOperada = (cajaOperada) =>
    sessionStorage.setItem('cajaOperada', JSON.stringify(cajaOperada))
export const getCajaOperada = () =>
    JSON.parse(sessionStorage.getItem('cajaOperada') ?? '{}')

export const User = () => {
    let token = getToken()
    return {
        id: token?.jti?.split('-')[1] ?? null,
        user: token?.sub ?? null,
        nombre: token?.name ?? null
    }
}

export const Config = () => ({
    DECIMALES_IMPORTE: Tenant().decimalesImporte ?? 2,
    DECIMALES_CANTIDAD: Tenant().decimalesCantidad ?? 2,
    SEPARADOR_DECIMAL: ',',
    SEPARADOR_DE_MILES: '.',
    SIMBOLO_MONETARIO: '$'
})